// frontend/src/components/DocumentTab/DocumentTab.js
import React from "react";
import JournalSection from "../JournalSection/JournalSection";

/**
 * DocumentTab
 *
 * Props
 *  • doc                 – { docId, title, sections, streaming, template_id }
 *  • onChangeSection(i, field, val)
 *  • handleCopyContent(text)      – kopiera-knappen
 *  • showTransferButton           – visa ”För över till TakeCare”
 *  • onTransferClick(doc)         – callback när knappen klickas
 */
function DocumentTab({
  doc,
  onChangeSection,
  handleCopyContent = () => {},
  showTransferButton = false,
  onTransferClick = () => {},
}) {
  return (
    <div className="document-tab">
      <h3>{doc.title}</h3>

      {doc.sections.map((sec, idx) => (
        <JournalSection
          key={idx}
          index={idx}
          section={sec}
          handleSectionChange={(i, field, val) =>
            onChangeSection(doc.docId, i, field, val)
          }
          handleCopyContent={() => handleCopyContent(sec.content.trim())}
          showDeleteButton={false}
          showCopyButton
        />
      ))}

      {/* --- Transfer till TakeCare (visa endast om flaggan är sann) --- */}
      {showTransferButton && (
        <button
          className="transfer-button"
          onClick={() => onTransferClick(doc)}
          disabled={doc.streaming}           /* lås medan GPT streamar */
        >
          För över till TakeCare
        </button>
      )}
    </div>
  );
}

export default DocumentTab;
